var exports = {
  "k": "x234b8571--b5f87c--container",
};

module.exports = exports;
